export const getCapitalizedWord = (string: string) => string.charAt(0).toUpperCase() + string.slice(1).toLocaleLowerCase();